<template>

  <div class="admin-body">
    <el-row ref="searchBar" style="position: fixed; top: 50px; width: 100%; overflow: hidden; z-index: 999;">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/Gzh' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>消息列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{nameyh}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <!-- <view ref="classifyContent" :style="{height: mdhd + 'px'}" id="chatContainer" class="main"> -->
    <el-row ref="classifyContent" :style="{height: mdhd + 'px'}" id="chatContainer"
      style="width: 100%; padding: 90px 10px; overflow-y: auto;">
      <el-row v-for="(item,index) in JlData" :key="index" style="position: relative;">
        <div class=""
          style="position: absolute; transform: translateX(-50%); left: 50%; top: -30px; color: rgba(0, 0, 0, 0.6); font-size: 18px;"
          v-if="item.show_time">
          {{item.creat_time}}
        </div>
        <el-row class="item1" v-if="item.type == 1">
          <img :src="item.tx ? 'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/' + item.tx : '../../assets/txyh.png'"
            style="width: 76px; height: 76px;" alt="">
          <el-row class="t1">
            {{item.txt}}
          </el-row>
        </el-row>

        <el-row style="margin-bottom: 30px; display: flex; justify-content: right;" v-if="item.type == 2">
          <el-row class="t2" v-if="item.txt">
            {{item.txt}}
          </el-row>
          <img :src="item.image" style="width: 100px; height: 100px; margin-right: 10px;" alt="" v-if="item.image">
          <a class="t2" :href="item.link" v-if="item.link">item.link</a>
          <audio v-if="item.voice" style=" width: 220px;!important" ref="audio" :src="item.voice" controls="controls">
          </audio>

          <img src="../../assets/dstx.png" style="width: 76px; height: 76px;" alt="">
        </el-row>
      </el-row>
    </el-row>

    <el-row ref="bottomOperateBtn">
      <div style="position: fixed; bottom: 0; width: 100%; height: 88px; background-color: #e9e9e9; display: flex;
        align-items: center; box-sizing: border-box;">
        <input type="text" placeholder="输入消息" v-model="Text"
          style=" width: 70%; height: 60px; background-color: #ffffff; border: none; border-radius: 10px; margin-left: 50px; font-size: 26px; outline-style: none; box-sizing: border-box; padding-left: 10px;">
        <div
          style="padding: 10px 20px; background-color: #05C160; margin-left: 50px; border-radius: 10px; color: #ffffff; font-size: 26px; cursor: pointer;"
          @click="getxx()">发送</div>
      </div>

    </el-row>



  </div>
</template>

<script>
  export default {
    name: "User",
    mounted() {

    },
    data() {
      return {
        value1: '',
        input3: '',
        select: '',
        Datalist: [],
        data: [],
        Getpos: {
          keyword: '',
          star_time: '',
          end_time: '',
          page: '',
          pageSize: 10
        },
        total: 0,
        mdhd: 0,
        JlData: [],
        Text: '',
        showDurationSeconds: 8, // 语音时长
        nameyh: '用户'
      }
    },
    computed: {

    },
    mounted() {
      console.log(this.$route.params.user_id, 'id!!!!!!!');
      // this.$route.params.testParams;
      this.Getlist()
      const searchBarHeight = this.$refs.searchBar.$el.offsetHeight;
      const bottomBtnHeight = this.$refs.bottomOperateBtn.$el.offsetHeight;
      const height = window.innerHeight;
      console.log(searchBarHeight, '高度', bottomBtnHeight, height);
      this.mdhd = height - bottomBtnHeight - searchBarHeight
    },

    watch: {
      JlData() {
        this.$nextTick(() => {
          var container = this.$el.querySelector("#chatContainer");
          container.scrollTop = container.scrollHeight;
        })

      }
    },
    methods: {
      getxx() {
        let _this = this
        if (this.Text == '') {
          this.$message({
            message: '请填写内容',
            type: 'warning'
          });
          return
        }
        this.$http.post(global.posturl.host + '/AutoNews/setNews', {
          content: this.Text,
          user_id: this.$route.params.user_id
        }).then(function(response) {
          console.log(response.data, '发送成功')
          if (response.data.code == '1') {
            let obj = {
              type: 2,
              txt: _this.Text
            }
            _this.JlData.push(obj)
            _this.Text = ''
            // _this.Getlist()
            // this.Datalist = response.data.data
          }
        }).catch(function(error) {
          console.log(error)
        })
      },
      // 设置语音条宽度样式
      handleAudioStyleWidth() {
        if (this.showDurationSeconds === 1) {
          return "38px";
        } else if (this.showDurationSeconds > 1 && this.showDurationSeconds < 20) {
          return `${38 + (this.showDurationSeconds / 10) * 36}px`;
        } else if (this.showDurationSeconds >= 20) {
          return `${106.39 + (this.showDurationSeconds / 10) * 18.935}px`;
        }
      },
      playAudio(url, index) {
        if (this.aud != null) {
          this.aud.pause();
          this.aud = null;
        }
        this.listData[index].ck = true
        console.log(this.aud, '音频');
        if (!this.listData[index].Ck) {
          console.log('开始');
          this.aud = new Audio(url);
          this.aud.play();
        } else {

        }

        // 若当前为播放状态则关闭
        if (this.listData[index].Ck) return this.listData[index].Ck = false

        this.listData[index].Ck = true;
        // 计时停止播放语音
        this.playAudioTimer = setTimeout(() => {
          this.listData[index].Ck = false;
        }, parseInt(this.listData[index].sj * 1000));

      },
      getN() {
        let obj = {
          type: 2,
          txt: this.Text
        }
        this.JlData.push(obj)
        this.Text = ''
      },
      filterTime(time) {
        var date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        var s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + m + "-" + d
        // + " " + h + ":" + minute + ":" + s;
      },
      rqCk(e) {
        console.log(e);
        if (e) {
          this.Getpos.star_time = this.filterTime(e[0])
          this.Getpos.end_time = this.filterTime(e[1])

        } else {
          this.Getpos.star_time = ''
          this.Getpos.end_time = ''
        }
        this.Getlist()
      },
      Getlist() {
        let _this = this
        this.$http.post(global.posturl.host + '/AutoNews/newsAdminLog', {
          user_id: this.$route.params.user_id
        }).then(function(response) {
          console.log(response.data, '成功111111')
          // JlData
          // let arr = []
          // arr.forEach()
          response.data.data.forEach((item, index) => {
            let obj11
            if (item.admin_type == 0) {
              _this.nameyh = item.name
              obj11 = {
                type: 1,
                txt: item.content,
                tx: item.image_url,
                show_time: item.show_time,
                creat_time: item.creat_time
              }
              _this.JlData.push(obj11)
            } else {
              if (item.content) {
                _this.JlData.push({
                  type: 2,
                  ty: 1,
                  txt: item.content,
                  show_time: item.show_time,
                  creat_time: item.creat_time
                })
              }
              if (item.voice) {
                _this.JlData.push({
                  type: 2,
                  ty: 1,
                  voice: item.voice,
                  sj: '',
                  Ck: false
                })

                // _this.getTimes(item.voice, index)
              }

              if (item.image) {
                _this.JlData.push({
                  type: 2,
                  ty: 1,
                  image: item.image,
                  show_time: item.show_time,
                  creat_time: item.creat_time
                })
              }
              if (item.link) {
                _this.JlData.push({
                  type: 2,
                  ty: 1,
                  link: item.link,
                  show_time: item.show_time,
                  creat_time: item.creat_time
                })
              }
            }
          })
        }).catch(function(error) {
          console.log(error)
        });
      },
      getTimes(url, index) {
        // var content = file;
        // //获取录音时长
        // var url = URL.createObjectURL(content);
        //经测试，发现audio也可获取视频的时长
        var audioElement = new Audio(url);
        let js = 0
        audioElement.addEventListener("loadedmetadata", (_event) => {
          js = parseInt(audioElement.duration);
          // console.log(js, '！！！！！！！！');
          // return js;
          let obj2 = {
            type: 2,
            ty: 1,
            voice: url,
            sj: js,
            Ck: false
          }
          this.JlData.splice(index, 0, obj2)
        });

      },
      Cx() {
        console.log('kais ');
        this.Getpos.keyword = this.input3
        this.Getlist()
      },
      CK(e) {
        console.log(e);
        this.Getpos.page = e
        this.Getlist()
      }
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    /* background-color: rgba(239, 243, 247, 1); */
    width: 100%;
    height: 100%;
    position: relative;
  }

  .item1 {
    margin: 30px 0;
    display: flex;
    justify-content: left;
  }

  .t1 {
    max-width: 86%;
    padding: 10px;
    font-size: 30px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin-left: 10px;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .t2 {
    max-width: 86%;
    padding: 10px;
    font-size: 30px;
    background-color: #95EB6C;
    border-radius: 10px;
    margin-right: 10px;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .hdss {
    /* width: 1576px; */
    height: 82px;
    background-color: #ffffff;
    margin: 17px 34px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .hdss1 {
    /* width: 1576px; */
    height: 142px;
    background-color: #ffffff;
    margin: 10px 34px;
    padding: 30px 30px;
    box-sizing: border-box;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/page/user/GzhXq.vue